import type { FC } from "react";
import { Label as AriaLabel } from "react-aria-components";
import { twMerge } from "tailwind-merge";
import { Size } from "../helpers/helpers.js";

interface LabelProps {
  size: Size;
  children: React.ReactNode;
  variant?: "default" | "secondary";
  id?: string;
  className?: string;
}

export const Label: FC<LabelProps> = ({
  children,
  size,
  id,
  className,
  variant,
}) => {
  const baseClasses =
    "leading-6 block flex flex-row items-center font-semibold";

  const variantClasses =
    variant === "secondary" ? "text-muted-foreground" : "text-foreground";

  return (
    <AriaLabel
      id={id}
      className={twMerge(
        baseClasses,
        getSizeClasses(size),
        variantClasses,
        className,
      )}
    >
      {children}
    </AriaLabel>
  );
};

function getSizeClasses(size: Size): string {
  switch (size) {
    case Size.SMALL:
      return "text-sm";
    case Size.MEDIUM:
      return "text-md";
    case Size.LARGE:
      return "text-lg mb-2";
  }
}
